<template>
  <div class="language-switcher inline-flex items-center rounded-md border border-primary overflow-hidden h-7 relative">
    <!-- Background slider that moves with the selection -->
    <div 
      class="absolute h-full bg-primary transition-transform duration-300 ease-in-out" 
      :style="{ width: '50%', transform: `translateX(${currentLocale === 'en' ? '0%' : '100%'})` }"
    ></div>
    
    <!-- Language buttons -->
    <button 
      v-for="locale in availableLocales" 
      :key="locale.code"
      @click="changeLanguage(locale.code)"
      class="px-2 py-0.5 text-xs font-medium transition-all duration-300 ease-in-out min-w-[28px] flex items-center justify-center relative z-10"
      :class="{ 
        'text-white': currentLocale === locale.code, 
        'text-gray-700 hover:text-gray-900': currentLocale !== locale.code 
      }"
    >
      {{ locale.displayName }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Locale {
  code: string;
  displayName: string;
}

export default defineComponent({
  setup() {
    const i18n = useI18n();
    
    const availableLocales: Locale[] = [
      { code: 'en', displayName: 'EN' },
      { code: 'fr', displayName: 'FR' }
    ];
    
    const changeLanguage = (lang: string): void => {
      i18n.locale.value = lang;
      localStorage.setItem('language', lang);
    };
    
    const currentLocale = computed(() => i18n.locale.value);
    
    return {
      currentLocale,
      availableLocales,
      changeLanguage
    };
  }
});
</script>

<style scoped>
.language-switcher {
  display: flex;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

button {
  cursor: pointer;
  flex: 1;
  user-select: none;
  transition: color 0.3s ease;
}

button:focus {
  outline: none;
}

/* Remove the default button styling */
button {
  background: transparent;
  border: none;
}
</style> 